import { render, staticRenderFns } from "./buyCard.vue?vue&type=template&id=296dd183&"
import script from "./buyCard.vue?vue&type=script&lang=js&"
export * from "./buyCard.vue?vue&type=script&lang=js&"
import style0 from "./buyCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports